import styled from 'styled-components'

import { PageFace } from '../../types'

export const Box = styled.header<{ face?: PageFace }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 94px;
  flex-shrink: 0;
  padding: 0 50px;
  background: ${(p) =>
    p.face === 'secondary'
      ? p.theme.uiKit.colors.theme.brand.primary
      : p.face === 'disabled'
        ? p.theme.uiKit.colors.global.grey.grey700
        : 'transparent'};
  border-top-left-radius: ${(p) => (p.face === 'secondary' ? 32 : 0)}px;
  color: ${(p) => (p.face === 'primary' ? p.theme.uiKit.colors.global.general.secondary : '#fff')};
`

export const Caption = styled.div`
  flex: 1;
  overflow: hidden;
  text-align: left;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
`
